.countBadge {
  width: 24px;
  height: 24px;
  font-size: 0.75rem;
  line-height: 0.75;
}

.counterWrapper {
  text-align: end;
}
